import styled from 'styled-components';
import { OutlineButton } from '@chegg-ui/button';
/**
 * A small wrapper around chegg-ui outline button which allows the host application to control
 * the color of the button when it is enabled.
 */
export var CustomColorOutlineButton = styled(OutlineButton).withConfig({
  componentId: "sc-1bwxyz9-0"
})(["", " white-space:nowrap;"], function (_ref) {
  var color = _ref.color;
  return color && "\n    &:enabled {\n      color: ".concat(color, ";\n      border-color: ").concat(color, ";\n      &:hover {\n        background-color: ").concat(color, ";\n        border-color: ").concat(color, ";\n        color: #FFF;\n      };\n    };\n  ");
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/common/styled/CustomColorOutlineButton.js
// module id = 4563
// module chunks = 11